"use client";

import * as React from "react";

type MediaQueryResult = {
  matches: boolean;
  ready: boolean;
};

export function useMediaQuery(query: string): MediaQueryResult {
  const getSnapshot = React.useCallback((): boolean => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  }, [query]);

  const [matches, setMatches] = React.useState<boolean>(getSnapshot);
  const [ready, setReady] = React.useState<boolean>(
    typeof window !== "undefined",
  );

  React.useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);
    setReady(true);

    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    if (typeof mediaQueryList.addEventListener === "function") {
      mediaQueryList.addEventListener("change", onChange);
      return () => mediaQueryList.removeEventListener("change", onChange);
    }

    mediaQueryList.addListener(onChange);
    return () => mediaQueryList.removeListener(onChange);
  }, [query]);

  return { matches, ready };
}
